import type { IconData } from '@stacksjs/iconify-core'

export const cut: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M23 31.1a128 128 0 0 1-5.312-3.075a9 9 0 1 1-10.943-.332c1.187-.969 3.139-2.262 5.505-3.693c-2.366-1.431-4.318-2.724-5.506-3.693a9 9 0 1 1 10.943-.332S32.156 11 38 11c4.312 0 6.486 2.513 7.367 3.926c.305.489.036 1.084-.511 1.263C41.862 17.167 32.666 20.252 24 24a217 217 0 0 0 10.056 4.025M15 13a3 3 0 1 1-6 0a3 3 0 0 1 6 0m0 22a3 3 0 1 0-6 0a3 3 0 0 0 6 0m16-2h-2m9 0h-2m9 0h-2\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cut
